<template>
  <div class="product">
    <Banner
      ref='cBanner'
      :banner_img="resBanners"
      banner_en="PRODUCTION CENTER"
      banner_cn="产品中心"
    ></Banner>
    <div class="zyproduct marginT60 wow fadeInUp animated">
      <recruitTit cn="主营产品" en="MAIN PRODUCT"></recruitTit>
    </div>
    <div class="mainBody marignT40 wow fadeInUp animated">
      <div class="mainproduct clear">
        <div
          class="mainproduct_img"
          v-for="(item, index) in shoplist1"
          :key="index"
          @click="
            $router.push({ name: 'product-detail', query: { id: item.id } })
          "
        >
          <img :src="item.img" :alt="item.text" />
        </div>
      </div>
    </div>
    <div class="zyproduct marginT60 wow fadeInUp animated">
      <recruitTit cn="延伸产品" en="AUGMENTED PRODUCT"></recruitTit>
    </div>
    <div class="mainBody marginT40 wow fadeInUp animated">
      <shop :shoplist="shoplist2"></shop>
    </div>
    <div class="pagecon">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="companyPageSize"
        :total="companyTotal"
        @size-change="getCompanyPage"
        @current-change="getCompanyPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/common/Banner.vue";
import recruitTit from "@/components/common/recruitTit";
import shop from "@/components/product/shop.vue";
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  data() {
    return {
      resBanners: [
        // {
        //   imageUrl: require("../assets/images/product/banner.png"),
        //   skipHref: "",
        // },
      ],
      shoplist1: [
        {
          id: 0,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/mainpro1.png"),
          text: "广达牌樟脑",
        },
        {
          id: 1,
          iconSrc: require("../assets/images/product/icon3.png"),
          img: require("../assets/images/product/mainpro2.png"),
          text: "白雪牌冰片",
        },
      ],
      shoplist2: [
        {
          id: 2,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop1.png"),
          text: "广达牌莰烯",
        },
        {
          id: 3,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop2.png"),
          text: "广达牌双戊烯",
        },
        {
          id: 4,
          iconSrc: require("../assets/images/product/icon2.png"),
          img: require("../assets/images/product/shop3.png"),
          text: "三春牌醋酸钠",
        },
        {
          id: 5,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop4.png"),
          text: "广达牌乙酸异龙脑酯",
        },
        {
          id: 6,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop5.png"),
          text: "广达牌蒎烯",
        },
        {
          id: 7,
          iconSrc: require("../assets/images/product/icon1.png"),
          img: require("../assets/images/product/shop6.png"),
          text: "广达牌异龙脑",
        },
      ],
      companyTotal: 1, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 5, // 每页显示条数
    };
  },
  computed: {},
  mounted() {
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "2",
      });
      if (res.code === 200) {
        this.resBanners = [];
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl
        });
        this.resBanners = res.rows;
        this.$nextTick(() => {
          this.$refs.cBanner.reInitBanner();
        });
      }
    },
    async getCompanyPage(page) {
      // 获取第 page 页数据
      // console.log(page);
      this.companyPageNo = page;
      this.getInfoManageList();
    },
    async getInfoManageList() {
      let res = await this.$request.getInfoManageList({
        pageNo: this.companyPageNo,
        pageSize: this.companyPageSize,
      });
      res.rows.map((val, index) => {
        val.infoContent = this.removeHTMLTag(val.infoContent);
      });
      this.companyNewsList = res.rows;
      this.companyTotal = res.total;
      // console.log(res);
    },
  },
  components: {
    Banner,
    recruitTit,
    shop,
  },
};
</script>

<style lang="scss" scoped>
.mainproduct {
  margin-top: 1.56vw;
  .mainproduct_img {
    float: left;
    width: 35.63vw;
    height: 14.58vw;
    overflow: hidden;
    cursor: pointer;
    &:first-child {
      margin: 0 1.56vw 0 0;
    }
    img {
      width: 100%;
    }
  }
}
.pagecon {
  text-align: center;
  padding: 2.08vw 0;
}
@media (min-width: 1920px) {
  .mainproduct {
    margin-top: 30px;
    .mainproduct_img {
      width: 684px;
      height: 280px;
      overflow: hidden;
      &:first-child {
        margin: 0 30px 0 0;
      }
      img {
        width: 100%;
      }
    }
  }
  .pagecon {
    text-align: center;
    padding: 40px 0;
  }
}
.pagecon /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #83bb26;
  color: #fff;
}

.pagecon /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #83bb26;
}
</style>